import type { ComponentProps } from 'react';

const AvatarMale = (props: ComponentProps<'svg'>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
      fill="#ECF7F6"
    />
    <mask
      id="mask0_4993_90850"
      mask-type="alpha"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <path
        d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
        fill="#ECF7F6"
      />
    </mask>
    <g mask="url(#mask0_4993_90850)">
      <path
        d="M12.6537 17.5423H10.8014C8.6789 17.5423 6.95801 15.8214 6.95801 13.6989V8.67985C6.95801 6.55734 8.6789 4.83645 10.8014 4.83645H12.6537C14.7763 4.83645 16.4972 6.55734 16.4972 8.67985V13.6989C16.4972 15.8214 14.7763 17.5423 12.6537 17.5423Z"
        fill="#FFBF9F"
      />
      <path
        d="M6.95508 11.1261V8.67743C6.95508 6.55491 8.67597 4.83401 10.7985 4.83401H12.6508C14.7733 4.83401 16.4942 6.55491 16.4942 8.67743V11.1261L9.30883 7.74517L6.95508 11.1261Z"
        fill="#263F43"
      />
      <path
        d="M6.39066 13.8474C7.19052 13.8474 7.83893 13.199 7.83893 12.3992C7.83893 11.5993 7.19052 10.9509 6.39066 10.9509C5.5908 10.9509 4.94238 11.5993 4.94238 12.3992C4.94238 13.199 5.5908 13.8474 6.39066 13.8474Z"
        fill="#FFBF9F"
      />
      <path
        d="M17.0713 13.8474C17.8712 13.8474 18.5196 13.199 18.5196 12.3992C18.5196 11.5993 17.8712 10.9509 17.0713 10.9509C16.2715 10.9509 15.623 11.5993 15.623 12.3992C15.623 13.199 16.2715 13.8474 17.0713 13.8474Z"
        fill="#FFBF9F"
      />
      <path
        d="M14.3156 12.701C14.5724 12.701 14.7805 12.3741 14.7805 11.9708C14.7805 11.5675 14.5724 11.2405 14.3156 11.2405C14.0589 11.2405 13.8507 11.5675 13.8507 11.9708C13.8507 12.3741 14.0589 12.701 14.3156 12.701Z"
        fill="#263F43"
      />
      <path
        d="M9.19892 12.701C9.45568 12.701 9.66382 12.3741 9.66382 11.9708C9.66382 11.5675 9.45568 11.2405 9.19892 11.2405C8.94215 11.2405 8.73401 11.5675 8.73401 11.9708C8.73401 12.3741 8.94215 12.701 9.19892 12.701Z"
        fill="#263F43"
      />
      <path
        d="M26.2964 38.0398H-2.29431V25.1173C-2.29431 21.4126 0.709341 18.409 4.41401 18.409H19.588C23.2927 18.409 26.2964 21.4126 26.2964 25.1173V38.0398V38.0398Z"
        fill="#5BAFA9"
      />
      <mask
        id="mask1_4993_90850"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="-3"
        y="18"
        width="30"
        height="21"
      >
        <path
          d="M26.2964 38.0398H-2.29431V25.1173C-2.29431 21.4126 0.709341 18.409 4.41401 18.409H19.588C23.2927 18.409 26.2964 21.4126 26.2964 25.1173V38.0398V38.0398Z"
          fill="#5BAFA9"
        />
      </mask>
      <g mask="url(#mask1_4993_90850)">
        <path
          d="M12.0004 22.0869L16.3841 21.0548L14.0596 16.9948L12.0004 22.0869Z"
          fill="#4F9493"
        />
        <path
          d="M12.0009 22.0869L7.74854 20.8236L9.94164 16.9948L12.0009 22.0869Z"
          fill="#4F9493"
        />
        <path
          d="M12.0005 22.0869L16.7056 12.7547H7.29541L12.0005 22.0869Z"
          fill="#FFBF9F"
        />
      </g>
      <path
        d="M13.7148 13.4312L11.7919 14.7164C11.7919 14.7164 12.5635 15.7972 13.5274 15.1375C14.4499 14.5022 13.7148 13.4312 13.7148 13.4312Z"
        fill="white"
      />
      <path
        d="M11.1663 11.0385V12.9687C11.1663 12.9687 10.3655 12.718 10.4701 13.2292C10.5748 13.7403 11.1663 13.9935 11.1663 13.9935"
        stroke="#263F43"
        stroke-width="0.570623"
        stroke-miterlimit="10"
        stroke-linejoin="round"
      />
    </g>
  </svg>
);

export default AvatarMale;
